(function () {
  'use strict';

  var desktopMedia = window.matchMedia('(min-width: 1024px)');

  function setExpanded(button, panel, expanded) {
    if (!button || !panel) return;

    button.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  }

  function initializeHeader(header) {
    if (!header || header.dataset.emporiaInitialized === 'true') return;

    var navToggle = header.querySelector('[data-emporia-nav-toggle]');
    var mobileShell = header.querySelector('[data-emporia-mobile-shell]');
    var navCloseButtons = header.querySelectorAll('[data-emporia-nav-close]');
    var searchToggle = header.querySelector('[data-emporia-search-toggle]');
    var searchPanel = header.querySelector('[data-emporia-search-panel]');

    header.dataset.emporiaInitialized = 'true';

    function setNavOpen(open, restoreFocus) {
      if (!navToggle || !mobileShell) return;

      setExpanded(navToggle, mobileShell, open);
      document.documentElement.classList.toggle('emporia-nav-open', open);
      document.body.classList.toggle('emporia-nav-open', open);
      navToggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');

      if (open) {
        var closeButton = mobileShell.querySelector('.emporia-header__mobile-close');
        if (closeButton) closeButton.focus();
      } else if (restoreFocus) {
        navToggle.focus();
      }
    }

    if (navToggle && mobileShell) {
      navToggle.addEventListener('click', function () {
        var shouldOpen = navToggle.getAttribute('aria-expanded') !== 'true';

        setNavOpen(shouldOpen, false);

        if (shouldOpen && searchToggle && searchPanel) {
          setExpanded(searchToggle, searchPanel, false);
        }
      });

      navCloseButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          setNavOpen(false, true);
        });
      });
    }

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var shouldOpen = searchToggle.getAttribute('aria-expanded') !== 'true';

        setExpanded(searchToggle, searchPanel, shouldOpen);

        if (shouldOpen) {
          setNavOpen(false, false);
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
    }

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      if (navToggle && mobileShell && navToggle.getAttribute('aria-expanded') === 'true') {
        setNavOpen(false, true);
      } else if (searchToggle && searchPanel && searchToggle.getAttribute('aria-expanded') === 'true') {
        setExpanded(searchToggle, searchPanel, false);
        searchToggle.focus();
      }
    });

    if (mobileShell) {
      mobileShell.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;

        var focusable = Array.prototype.filter.call(
          mobileShell.querySelectorAll('a[href], button:not([tabindex="-1"]), summary'),
          function (element) {
            return element.offsetParent !== null;
          }
        );
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    desktopMedia.addEventListener('change', function (event) {
      if (!event.matches || !navToggle || !mobileShell) return;

      setNavOpen(false, false);
    });
  }

  function initialize(root) {
    root.querySelectorAll('[data-emporia-header]').forEach(initializeHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
